<template>
  <notifications
      class="tm-notifications" position="top right">
  </notifications>
</template>

<script>
export default {
  name: "vNotification",
}
</script>
<style>
.vue-notification-group {
  position: fixed;
  z-index: 9999;
}
</style>
